export const SELECT_PLAN_BASE_ROUTE = '/plans';
export const CONFIRM_VIEW_ROUTE = 'payment-confirmation';
export const PAYMENT_VIEW_ROUTE = 'payment-details';
export const SUMMARY_VIEW_ROUTE = 'summary';

export const TRIAL_BUY_NOW_BASE_ROUTE = '/trials/buy-now';
export const TRIAL_CHECKOUT_ROUTE = 'checkout';

export const BILLING_ADDRESS = 'billing-address';
export const BUSINESS_ADDRESS = 'business-address';

export const SUCCESSFUL_PAID_CONVERSION = 'successfulPaidConversion';
